<template>
  <LoginLayoutFrame
    :login-text="loginText"
    :brand-text="$t('header.automated_animal_recording_system')"
    :copyright-text="$t('auth.rights')"
    main-class="my-0"
  >
    <template #language-selector>
      <LanguageSelector />
    </template>
    <slot />
  </LoginLayoutFrame>
</template>
<script setup lang="ts">
const { t: $t } = useI18n()

import { computed, useRoute } from '#imports';
import { LoginLayoutFrame } from 'r3ui-lib/login';
import LanguageSelector from '~/modules/locale/LanguageSelector.vue';

const route = useRoute();

const loginText = computed(() => {
  if (route.name === 'login') {
    return $t('auth.Authorization');
  }
  return '';
});
</script>
